import React from "react";

export default function Backtop() {
    return(
        <div className="go-top">
          <i className="fas fa-chevron-up"></i>
          <i className="fas fa-arrow-up"></i>
        </div>
    );
}